<template>
    <modal name="new_investor_employment_modal" height="auto" :clickToClose="false" :scrollable="true" :adaptive="true" :reset="true" @closed="onClose" >
        <div class="modal-content">
            <div class="modal-header pt-3 pr-0">
                <div class="col-md-12 pl-0">
                    <h3 class="mb-1">Let's make sure your information is up to date.</h3>
                    <span class="small mb-0 pull-left">Kindly provide us the relevant information to allow us to review the funds of your investment. Please be assured that all information and documents provided will remain confidential and secure.</span>
                </div>
            </div>
            <div class="row" style="padding-left: 25px; padding-right: 25px;">
                <div class="col-sm-12"><hr></div>
            </div>
            <div class="modal-body" v-if="this.formLoading == false">
                <div class="row">
                    <label class="col-sm-4 col-form-label">Employment</label>
                    <div class="col-sm-8">
                        <div class="form-group">
                            <select class="form-control"
                                    v-model="user_info.inv_occupation">
                                <option :value="null">- Select -</option>
                                <option value="Unemployed">Unemployed</option>
                                <option value="Student">Student</option>
                                <option value="Full time">Full time</option>
                                <option value="Part time">Part time</option>
                                <option value="Self employed">Self employed</option>
                                <option value="Retired">Retired</option>
                            </select>
                            <p class="small text-danger" v-if="errors.occupation">
                                <span class="d-block" v-for="e, key in errors.occupation" v-bind:key="key">{{ e }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="(user_info.inv_occupation == 'Full time' || user_info.inv_occupation == 'Part time')">
                    <label class="col-sm-4 col-form-label">Name of Employer</label>
                    <div class="col-sm-8">
                        <div class="form-group">
                            <input type="text" class="form-control"
                                    v-model="user_info.inv_employer">
                            <p class="small text-danger" v-if="errors.employer">
                                <span class="d-block" v-for="e, key in errors.employer" v-bind:key="key">{{ e }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="(user_info.inv_occupation == 'Unemployed' || user_info.inv_occupation == 'Student'
                    || user_info.inv_occupation == 'Self employed' || user_info.inv_occupation == 'Retired')">
                    <label class="col-sm-4 col-form-label">Source of Income</label>
                    <div class="col-sm-8">
                        <div class="form-group">
                            <input type="text" class="form-control"
                                    v-model="user_info.inv_source_of_income">
                            <p class="small text-danger" v-if="errors.source_of_income">
                                <span class="d-block" v-for="e, key in errors.source_of_income" v-bind:key="key">{{ e }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="(user_info.inv_occupation == 'Self employed')">
                    <label class="col-sm-4 col-form-label">Nature of Business</label>
                    <div class="col-sm-8">
                        <div class="form-group">
                            <input type="text" class="form-control"
                                    v-model="user_info.inv_nature_of_business">
                            <p class="small text-danger" v-if="errors.nature_of_business">
                                <span class="d-block" v-for="e, key in errors.nature_of_business" v-bind:key="key">{{ e }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-4 col-form-label">Annual Income</label>
                    <div class="col-sm-8">
                        <div class="form-group">
                            <select class="form-control"
                                    v-model="user_info.inv_income_range">
                                <option :value="null">- Select -</option>
                                <option value="below_50k">Below 50,000</option>
                                <option value="50k_100k">50,000 - 100,000</option>
                                <option value="100k_150k">100,000 - 150,000</option>
                                <option value="150k_300k">150,000 - 300,000</option>
                                <option value="300k_500k">300,000 - 500,000</option>
                                <option value="500k_1m">500,000 - 1,000,000</option>
                                <option value="above_1m">1,000,000 and above</option>
                            </select>
                            <p class="small text-danger" v-if="errors.income_range">
                                <span class="d-block" v-for="e, key in errors.income_range" v-bind:key="key">{{ e }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer row pb-3">
                <div class="col-md-12 d-flex flex-row justify-content-center">
                    <button @click.prevent="updateBasicInformation" class="btn btn-success pt-2 pb-2" :disabled="formLoading">Update</button>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
import UserSettingService from "../../services/UserSettingService";

export default {
    name: 'NewInvestorEmploymentModal',
    props: {
        user: {
            type: Object,
        },
    },
    data () {
        return {
            formLoading: false,
            errors: {
                occupation : null,
                employer : null,
                source_of_income : null,
                nature_of_business : null,
                income_range : null,
            },

            user_info: {
                // Employment Information
                inv_occupation : null,
                inv_employer : null,
                inv_source_of_income : null,
                inv_nature_of_business : null,
                inv_income_range : null,
            },
        }
    },
    created () {
        this.loadUserInformation();
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    mounted() {
        // Anything to do when DOM mounted

    },
    methods: {
        handleResize() {
            this.isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        },
        onClose () {
            // Anything to do on closing modal
            
        },
        resetErrors () {
            Object.keys(this.errors).forEach((key) => {
                this.errors[key] = null;
            });
        },
        loadUserInformation () {
            this.formLoading = true;
            UserSettingService.getUserInformation()
                .then((res) => {
                    this.user_info = res.data.user_info;
                    this.formLoading = false;
                }).catch((err) => {
                    this.$noty.error('Network error.');
                    this.formLoading = false;
                })
        },
        updateBasicInformation() {
            this.resetErrors();
            
            if (this.user_info.inv_occupation == 'Full time' || this.user_info.inv_occupation == 'Part time') {
                this.user_info.inv_source_of_income = null
                this.user_info.inv_nature_of_business = null
            }
            if (this.user_info.inv_occupation == 'Unemployed' || this.user_info.inv_occupation == 'Student' || this.user_info.inv_occupation == 'Retired') {
                this.user_info.inv_employer = null
                this.user_info.inv_nature_of_business = null
            }
            if (this.user_info.inv_occupation == 'Self employed') {
                this.user_info.inv_employer = null
            }
            axios.post('/api/settings/basic_information', {
                occupation: this.user_info.inv_occupation,
                employer: this.user_info.inv_employer,
                source_of_income: this.user_info.inv_source_of_income,
                nature_of_business: this.user_info.inv_nature_of_business,
                income_range: this.user_info.inv_income_range,
            }).then(() => {
                this.$noty.success('Successfully updated basic information')
                this.$modal.hide('new_investor_employment_modal');
            })
            .catch (err => {
                if (typeof err.response != 'undefined' && err.response.status === 422) {
                    Object.keys(this.errors).forEach((key,index) => {
                        if (typeof err.response.data.errors[key] !== 'undefined') {
                            this.errors[key] = err.response.data.errors[key];
                        }
                    });
                } else {
                    this.$noty.error('Error! Please try again!');
                }
            })
        },
    }
}
</script>
